// internal
import { axios, def, likesSynced, replaceLikes } from './internal';

// Loads this user's liked posts once per device so feed hearts are right on a new device (see liked-posts.js).
// Resolves either way; a failed load is retried with the next feed page.
let pending = null;
function LikeList() {
    if (likesSynced()) return Promise.resolve();
    pending ??= axios
        .get('/api/likes')
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) replaceLikes(res.data.data.likes);
        })
        .catch(() => {})
        .finally(() => {
            pending = null;
        });
    return pending;
}

export { LikeList };
